export default {
	COLLECTION_ID: 'ABOUT_DIALOG_COLLECTION',
	ABOUT_DIALOG_SHOW: 'ABOUT_DIALOG_SHOW',
	ABOUT_DIALOG_HIDE: 'ABOUT_DIALOG_HIDE',
};
